$(document).ready(function() {
  $('form.login-form').on('click', 'button', function () {
    localStorage.setItem('user_storage_key', $('#email').val());

    $(this).prop('disabled', true);
    $('form.login-form').submit();
  })
});
